'use client'

import { fulfillmentConfig } from '@entities/fulfillment'
import { faTelegram } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button } from '@ui/base/button'
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@ui/base/dialog'
import { typeClass } from '@utils/typography'
import { CheckIcon } from 'lucide-react'

type Props = {
  open: boolean
  onClose: () => void
}

/** Подтверждает отправку новой карточки и приглашает владельца в чат сообщества. */
export const FulfillmentCreatedDialog = ({ open, onClose }: Props) => (
  <Dialog
    open={open}
    onOpenChange={(isOpen) => {
      if (!isOpen) {
        onClose()
      }
    }}
  >
    {/* Базовый DialogContent ограничивает только ширину, а окно длинное: без предела высоты и
        прокрутки на невысоком экране кнопки уходят за край без возможности до них добраться. */}
    <DialogContent className="max-h-[calc(100dvh-2rem)] overflow-y-auto overscroll-contain">
      {/* Слева на любой ширине: базовая шапка центрирует текст на узком экране, и значок успеха
          оказывался у левого края, а заголовок — по центру. */}
      <DialogHeader className="items-start text-left">
        <span className="bg-success-soft text-success-soft-foreground flex size-11 items-center justify-center rounded-full">
          <CheckIcon className="size-6" aria-hidden="true" />
        </span>
        <DialogTitle>Карточка отправлена на проверку</DialogTitle>
        <DialogDescription>
          Мы посмотрим её и опубликуем в каталоге. Пока идёт проверка, карточка видна вам в разделе «Мои фулфилменты».
        </DialogDescription>
      </DialogHeader>

      <section
        className="bg-info-soft text-info-soft-foreground grid gap-3 rounded-lg p-4"
        aria-labelledby="fulfillment-community-chat-title"
      >
        <h3 id="fulfillment-community-chat-title" className={`${typeClass.sectionTitle} flex items-center gap-2`}>
          <FontAwesomeIcon icon={faTelegram} className="size-5" aria-hidden="true" />
          Чат фулфилментов Evirma
        </h3>
        <p className={typeClass.supporting}>
          Здесь собраны все фулфилменты сервиса. Обсуждаем, что удобно, что мешает и чего не хватает в работе с заявками
          и клиентами.
        </p>
        <ul className={`${typeClass.supporting} grid gap-2`}>
          <li className="flex gap-2">
            <CheckIcon className="mt-0.5 size-4 shrink-0" aria-hidden="true" />
            Говорите, какого функционала не хватает, — и это попадает в план работ.
          </li>
          <li className="flex gap-2">
            <CheckIcon className="mt-0.5 size-4 shrink-0" aria-hidden="true" />
            Общие проблемы решаются быстрее рядом с теми, кто через них уже прошёл.
          </li>
        </ul>
      </section>

      <p className={`${typeClass.supporting} text-muted-foreground`}>
        Вступление в чат — по заявке, мы одобряем её вручную.
      </p>

      <DialogFooter className="flex-col sm:flex-col">
        <Button render={<a href={fulfillmentConfig.communityChatUrl} target="_blank" rel="noopener noreferrer" />}>
          <FontAwesomeIcon icon={faTelegram} aria-hidden="true" />
          Вступить в чат
        </Button>
        <DialogClose render={<Button variant="ghost" />}>Перейти к моим фулфилментам</DialogClose>
      </DialogFooter>
    </DialogContent>
  </Dialog>
)
